<template>
<div class="elink likelink" @click="openlink">
	<slot></slot>
</div>
</template>

<style scoped lang="sass">

</style>

<script>
import {
	mapState
} from 'vuex';

function normalizeUrl(url) {
  if (!/^https?:\/\//i.test(url)) {
    return 'https://' + url;
  }
  return url;
}

export default {
	name: 'elink',
	props: {
		href: String
	},
	computed: mapState({
		auth: state => state.auth,
	}),

	methods: {
		openlink : function(){

			var hr = normalizeUrl(this.href)

			this.core.parental('openlink', {
				url : hr,
			}, () => {

				if (
					typeof window != "undefined" &&
					typeof window.cordova != "undefined" &&
					cordova.InAppBrowser
				) {
					cordova.InAppBrowser.open(hr, "_system");
					return false;
				} else {
					window.open(hr, "_blank");
				}

			})

			
		}
	},
}
</script>
